/** @jsxRuntime classic */
/** @jsx h */

const { h } = require('preact')
const MetaErrorMessage = require('@uppy/dashboard/lib/components/FileItem/MetaErrorMessage')

import {getFileTypeColor} from '../../../utils/getFileTypeIcon';
import FilePreview from '../../FilePreview';

export default function FilePreviewAndLink (props) {
  return (
    <div
      className="uppy-Dashboard-Item-previewInnerWrap"
      style={{ backgroundColor: getFileTypeColor(props.file.type) }}
    >
      {
        props.showLinkToFileUploadResult
        && props.file.uploadURL
          && (
          <a
            className="uppy-Dashboard-Item-previewLink"
            href={props.file.uploadURL}
            rel="noreferrer noopener"
            target="_blank"
            aria-label={props.file.meta.name}
          >
            <span hidden>{props.file.meta.name}</span>
          </a>
          )
      }
      <FilePreview file={props.file} />
      <MetaErrorMessage
        file={props.file}
        i18n={props.i18n}
        toggleFileCard={props.toggleFileCard}
        metaFields={props.metaFields}
      />
    </div>
  )
}
